import * as React from "react";
const SVGComponent = ({ color = "var(--border-color)", ...props }) => (
  <svg
    width={22}
    height={15}
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.541 12.3526L14.7228 7.95715L11.1385 10.6649C11.0605 10.7272 10.9482 10.7304 10.8639 10.6681L7.27644 7.95716L1.4615 12.3526C1.48959 12.5461 1.58015 12.7208 1.71104 12.8517H1.71418C1.87646 13.014 2.10105 13.1138 2.34746 13.1138H19.6521C19.8985 13.1138 20.1231 13.014 20.2853 12.8517C20.4194 12.7208 20.5099 12.5461 20.5412 12.3526L20.541 12.3526ZM14.5858 7.49551L11.0014 10.2064L7.4169 7.49864L7.40764 7.49236L1.44926 2.98762V1.8708C1.44926 1.6211 1.54908 1.3965 1.71434 1.23438C1.87663 1.0721 2.10121 0.969142 2.34763 0.969142H19.6522C19.8986 0.969142 20.1232 1.06896 20.2855 1.23438C20.4508 1.39651 20.5506 1.62109 20.5506 1.8708V2.98762L14.5922 7.49236L14.5858 7.49551ZM15.0942 7.67333L20.5503 3.54907V11.7972L15.0942 7.67333ZM1.44936 3.54907L6.90552 7.67333L1.44936 11.7972V3.54907ZM2.3477 0.52002H19.6523C20.0235 0.52002 20.3604 0.672884 20.6037 0.916149H20.6069C20.8501 1.15957 21 1.49953 21 1.87086V12.2154C21 12.5866 20.8501 12.9236 20.6069 13.17C20.3605 13.4133 20.0235 13.5661 19.6523 13.5661H2.3477C1.97967 13.5661 1.6427 13.4133 1.39943 13.17H1.39629C1.14988 12.9236 1 12.5866 1 12.2154V1.87086C1 1.49639 1.14988 1.15959 1.39629 0.916149C1.63955 0.672884 1.97649 0.52002 2.3477 0.52002Z"
      fill={color}
      stroke={color}
    />
  </svg>
);
export default SVGComponent;